import { EventConstants, CommonConstants } from '@/config/constant';

export default {
  parentEventInfo: (state) => {
    return state.parentEventInfo ? {
      ...(state.parentEventInfo || {}),
      isLoginNormal: !state.parentEventInfo?.useLoginSms,
      isLoginPhoneOrMail: state.parentEventInfo?.useLoginSms === CommonConstants.typeEmail,
      isLoginPhone: state.parentEventInfo?.useLoginSms === CommonConstants.typeSms,
      isLoginOnlyPhone: state.parentEventInfo?.useLoginSms === CommonConstants.typePhone,
      useSwitchCPMCard: state.parentEventInfo?.useSwitchCPMCard === CommonConstants.typeEmail,
      isCommonPoint: state.parentEventInfo?.typePoint === CommonConstants.typeEmail,
      isPrivatePoint: state.parentEventInfo?.typePoint === CommonConstants.typeSms,
      favicon: state.parentEventInfo?.favicon?.url,
      icon: state.parentEventInfo?.icon?.url,
      useTransferBalanceCpm: !!state.parentEventInfo?.useTransferBalanceCpm,
    } : null;
  },
  childEventList: (state) => {
    return state.parentEventInfo?.events;
  },
  childEventInfo: (state) => {
    return state.childEventInfo ? {
      ...(state.childEventInfo || {}),
      isPaymentTicketEventType: state.childEventInfo?.type === EventConstants.type.paymentTicket,
      expiredEvent: state.childEventInfo?.status?.id === EventConstants.status.expired.value,
      useContactFrontFlag: !!state.childEventInfo?.useContactFrontFlag,
      isNewPaymentDesign: !!state.childEventInfo?.isNewPaymentDesign,
    } : null;
  },
  isDisplayShopMenuFront: (state) => !!state.parentEventInfo?.displayShopMenuFront,
  isChargeableDate: (state) => state.childEventInfo?.canCharge,
  isPaymentEventType: (state) => {
    return [EventConstants.type.payment, EventConstants.type.paymentTicket].includes(state.childEventInfo?.type);
  },
  isCreditChargeType: (state) => state.childEventInfo?.chargeType?.creditcard?.use,
  isBankChargeType: (state) => state.childEventInfo?.chargeType?.maruPay?.use,
  monitoringFlag: (state) => state.childEventInfo?.monitoringFlag,
  isPaymentableDate: (state) => state.childEventInfo?.canPayment,
  hasBalanceFlag: (state) => state.parentEventInfo?.useTotalBalanceFlag === 1,
  isNewUIPointFlag: (state) => state.childEventInfo?.newUIPointFlag,
  useMemoFlag: (state) => state.childEventInfo?.useMemoFlag,
  useCsvTransaction: (state) => state.childEventInfo?.useCsvTransaction,
  hasHistoryPoint: (state) => state.childEventInfo?.hasHistoryPoint,
  hasHistoryCurrency: (state) => state.childEventInfo?.hasHistoryCurrency,
  isNewUiAndNotHasBalance(_, getters, rootGetters) {
    return getters.isNewUIPointFlag && !rootGetters?.auth?.infor?.balance && !!rootGetters?.auth?.infor?.point;
  },
  isUseTicketFlag: (state) => !!state.parentEventInfo?.useTicketFlag,
  isChildEventUseTicketFlag: (state) => [EventConstants.type.chargeTicket, EventConstants.type.paymentTicket].includes(state.childEventInfo?.type),
  useCurrencyFlag: (state) => !!state.childEventInfo?.useCurrencyFlag,
  useVerify: (state) => state.parentEventInfo?.useVerify,
  isDuplicateUser: (state) => state.isDuplicateUser,
  isErrorAddress: (state) => state.isErrorAddress,
  isErrorUser: (state) => state.isErrorUser,
  isValidUser: (state) => state.isValidUser,
  isValidKeyword: (state) => state.isValidKeyword,
  clientIdIdentity: (state) => state.parentEventInfo?.clientIdIdentity,
  urlFront: (state) => state.parentEventInfo?.urlFront,
  hostIdentity: (state) => state.parentEventInfo?.hostIdentity,
  realm: (state) => state.parentEventInfo?.realm,
  useOmise: (state) => state.parentEventInfo?.useOmise,
  partnerIdentity: (state) => state.parentEventInfo?.partnerIdentity,
  isXID: (state) => state.parentEventInfo?.partnerIdentity === CommonConstants.xID,
  isCivilios: (state) => state.parentEventInfo?.partnerIdentity === CommonConstants.civilios,
  isDigital: (state) => state.parentEventInfo?.partnerIdentity === CommonConstants.digital,
  useSms: (state) => state.childEventInfo?.useSms,
  isMatchKeyWord: (state) => state.childEventInfo?.isMatchKeyWord,
  phoneInfo: (state) => state.phoneInfo,
  identityVerification: (state) => state.childEventInfo?.identityVerification,
  usePosFlag: (state) => !!state.childEventInfo?.usePosFlag,
  noTypeMomentIdentity: (state) => state.childEventInfo?.typeMomentIdentity === 0,
  hasTypeMomentIdentity: (state) => state.childEventInfo?.typeMomentIdentity === 1,
  requestTypeMomentIdentity: (state) => state.childEventInfo?.typeMomentIdentity === 2,
  isCreditChargeWith3DS2: (state, getters) => {
    return getters.isCreditChargeType && state.childEventInfo?.chargeType?.creditcard?.['3ds'] === 2;
  },
  isBlockedSms: (state) => state.isBlockedSms,
  nativeType: (state) => state.parentEventInfo?.typeOtherApp === CommonConstants.nativeType,
  appType: (state) => state.parentEventInfo?.typeOtherApp === CommonConstants.appType,
  forgottenPwdUrlOtherApp: (state) => state.parentEventInfo?.forgottenPwdUrlOtherApp,
  registrationUrlOtherApp: (state) => state.parentEventInfo?.registrationUrlOtherApp,
  useLinkageAppAndNecFlag (_, getters, rootGetters) {
    return getters.parentEventInfo?.useLinkageNecFlag && rootGetters?.common?.isLinkageView;
  },
  useLinkageAppAndNotLoggedIn (_, getters, rootGetters) {
    return getters?.useLinkageAppAndNecFlag && !rootGetters?.auth?.token;
  },
  isPausedEvent: (state) => state.childEventInfo?.status?.id === EventConstants.status.paused.value
};
